import {axios} from "@/plugins/http-axios";
import {Module} from "vuex";

interface ICurrentStep {
    currentStep: number;
};

export default <Module<ICurrentStep, any>>{
    state:{
        currentStep: 2,
    },
    mutations:{
        setAppStep(state, step = 2) {
            state.currentStep = step;
        },
    },
    actions:{
        async requestAction({ dispatch, rootGetters }, payload) {
            try {
                const response = await axios.post(rootGetters.uri.action, payload)
                await dispatch('getApp', rootGetters.appId)
                return response
            } catch (error) {
                dispatch('setError', error)
                return error
            }
        },
    },
    getters:{
        currentStep: (state):number => state.currentStep,
    },
};
